import CircularProgress from '@mui/material/CircularProgress'
import * as React from 'react'
import { NameValueList } from '../../NameValueList/NameValueList'
import { useData } from './hooks'
import Box from '@mui/material/Box'
import { InfoBlurb } from './InfoBlurb'
import { SubmissionInfo } from './SubmissionInfo'

type Props = {
  draftLeadId: number | null
  hideInfoBox?: boolean
  dateSubmittedFormat?: string
  type: string
}

export function WebformSideDrawerContents(props: Props) {
  const { draftLeadId, hideInfoBox = false, dateSubmittedFormat } = props
  const { draft, loading, nameValueList } = useData({
    draftLeadId,
    showNulls: false,
  })

  return (
    <>
      {loading ? (
        <CircularProgress />
      ) : (
        <>
          {!hideInfoBox && <InfoBlurb />}
          <SubmissionInfo
            submittedBy={draft?.submittedBy}
            dateSubmitted={dateSubmittedFormat || draft?.createdTime}
            {...props}
          />

          {nameValueList.length > 0 ? (
            <NameValueList
              excludeNames={['SUBMITTEDBY', 'Type']}
              list={nameValueList}
              divider={false}
            />
          ) : (
            <Box>{draft?.note}</Box>
          )}
        </>
      )}
    </>
  )
}
